import AccordionArrow from "../../images/svg/single_down_arrow.svg"
import Table from '../Table/Table';
import { randomUUID } from "../../utils/randomUUID";

const Accordion = (props) => {
  let updaterec = props?.data;
  let openAcc = props?.from ==='job_Lvl' ? "" : "open";
  let openTab = updaterec?.title == "Primary" ? "open" : "";
  return (
    <details className={props?.from ==='job_Lvl' ? props.clsName + " group":props.clsName + " my_skillset group"} {...openAcc} {...openTab}{..."open"}>
      <summary className="flex justify-between items-center font-medium cursor-pointer list-none">
        <h2>{updaterec.title}</h2>
        <img src={AccordionArrow} className="transition rotate-180 group-open:rotate-0" alt="accordion-arrow" />
      </summary>
      <div className="text-neutral-600 group-open:animate-fadeIn table-data">
        {props?.from ==='job_Lvl' ? <>{props?.body}</> : 
        <>
        <Table key={randomUUID()} data={updaterec?.primary} />
        <Table key={randomUUID()} data={updaterec?.secondary} />
        </>
      }
      </div>
    </details>
  )
}

export default Accordion;